(function () {
  document.addEventListener('click', (event) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const button = event.target.closest('.button, .shopify-payment-button__button--unbranded');
    if (!button || button.disabled) return;

    let wrap = button.querySelector(':scope > .button-ripple-wrap');
    if (!wrap) {
      wrap = document.createElement('span');
      wrap.className = 'button-ripple-wrap';
      button.appendChild(wrap);
    }

    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 1.8;

    const ripple = document.createElement('span');
    ripple.className = 'button-ripple';
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${event.clientX - rect.left}px`;
    ripple.style.top = `${event.clientY - rect.top}px`;

    wrap.appendChild(ripple);
    ripple.addEventListener('animationend', () => ripple.remove());
  });
})();
